import * as XLSX from 'xlsx';

/**
 * Download an .xlsx workbook.
 * @param {string} filename e.g. opencare-batteristatus-2026-10-08.xlsx
 * @param {{ name: string, rows: Array<Record<string, string|number|null|undefined>> }[]} sheets
 */
export function downloadWorkbook(filename, sheets) {
  const workbook = XLSX.utils.book_new();

  for (const sheet of sheets) {
    const rows = sheet.rows || [];
    const headers = sheet.headers;
    let worksheet;
    if (rows.length) {
      worksheet = XLSX.utils.json_to_sheet(rows);
    } else if (headers?.length) {
      worksheet = XLSX.utils.aoa_to_sheet([headers]);
    } else {
      worksheet = XLSX.utils.aoa_to_sheet([[]]);
    }
    XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name.slice(0, 31) || 'Ark1');
  }

  XLSX.writeFile(workbook, filename);
}
